<tui-notification class="password-rules" appearance="neutral">
  @for (rule of passwordRules; track rule.labelKey) {
    <ion-password-rule
      [labelKey]="rule.labelKey"
      [invalid]="hasError(passwordModel(), rule.errorKeys)"
      [showError]="showError()"
      [isActive]="!!passwordModel().value"
    ></ion-password-rule>
  }

  <ion-password-rule
    labelKey="LOGIN.PASSWORD_RESET.RULE_MATCH"
    [invalid]="hasError(passwordConfirmModel(), ['required']) || resetForm().form.errors?.['passwordsMismatch']"
    [showError]="showError()"
    [isActive]="!!passwordConfirmModel().value"
  ></ion-password-rule>
</tui-notification>
